
import { observable, action, runInAction, toJS } from 'mobx';

class store {
    @observable visible = false;
    @observable name = "";
    @observable hotel = [];
    @observable hotelTotal = [];
    @observable selectedRowKeys = [];

    @action getData = () => {
        fetch('/getHeadquartersHotels', { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.status == 1) {
                runInAction(() => {
                    this.hotel = x.data.hotels || [];
                    this.hotelTotal = x.data.hotels || [];
                });
            }
        }).catch(err => {
            console.error(err);
        })
    }

    @action onShow = (id) => {
        this.visible = true;
        if (id) this.selectedRowKeys = [id]
    }

    @action onCancel = () => {
        this.visible = false;
    }

    @action onChange = (e) => {
        this.name = (e.target.value || "").trim();
    }

    @action onSearch = () => {
        let hotelTotal = [...toJS(this.hotelTotal)];
        let name = this.name;

        // 去除所有空格不区分大小写
        let hotel = hotelTotal.filter(x => (x.name.toUpperCase().replace(/\s+/g, "")).includes(name.toUpperCase().replace(/\s+/g, "")));
        this.hotel = hotel;
    }

    @action onOk = (fn) => {
        this.visible = false;
        if (fn) fn(this.selectedRowKeys[0])
    }

    @action onChangeRowKeys = (key, selectedRows) => {
        this.selectedRowKeys = key;
    }
}

const selectHotel = new store();

export default selectHotel;


// WEBPACK FOOTER //
// ./src/store/selectHotel.js